import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { TranslocoPipe } from '@jsverse/transloco';

import { DrawerService } from '@/core/drawer/drawer.service';

@Component({
  selector: 'dialab-drawer-outlet',
  imports: [NgComponentOutlet, CdkTrapFocus, TranslocoPipe],
  templateUrl: './drawer-outlet.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '(document:keydown.escape)': 'onEscape()' },
})
export class DrawerOutlet {
  protected readonly service = inject(DrawerService);
  protected readonly drawer = this.service.activeDrawer;
  protected readonly closing = this.service.closing;

  protected onBackdropClick(): void {
    this.dismissIfAllowed();
  }

  protected onEscape(): void {
    this.dismissIfAllowed();
  }

  protected onAnimationEnd(event: AnimationEvent): void {
    if (event.target !== event.currentTarget) return;
    this.service.exitAnimationEnded();
  }

  private dismissIfAllowed(): void {
    const active = this.drawer();
    if (active && active.options.backdropDismissable !== false) active.ref.dismiss();
  }
}
